import React, { useState, useContext } from "react";
import { useParams } from "react-router-dom";

import AlertContext from "../../context/AlertContext";
import { UserReportContext } from "../../context/UserReportContext";

// import Drawer from "./Drawer";
import UserReport from "../UserReport/UserReport";

import useAxiosPrivate from "../../Hooks/useAxiosPrivate";
import useCommonFunctionHooks from "../../Hooks/useCommonFunctionHooks";
import UserTestResultReportTableHooks from "../../Hooks/UserReport/UserTestResultReportTable/UserTestResultReportTableHooks";

import { getDataFromStorage } from "../../util";
import constants from "../../constants";
import Loading from "../Notification-Loading/Loading/Loading";
import { createPortal } from "react-dom";
const toPascalCase = (str) => {
  if (!str) return "";

  return str
    .trim()
    .split(/\s+/)
    .map(
      (word) =>
        word.charAt(0).toUpperCase() +
        word.slice(1).toLowerCase()
    )
    .join(" ");
};

const NameCell = ({ row, rowIndex = 0, className = "", pos = "body" }) => {
  const Alert = useContext(AlertContext);
  const UserReportCxt = useContext(UserReportContext);

  const axios = useAxiosPrivate();
  const commonFunctions = useCommonFunctionHooks();
  const reportTableHooks =
    UserTestResultReportTableHooks();

    console.log("pos:",pos);
    
  const { id } = useParams();
  const target = pos === "body"
    ? document.body
    : document.getElementById(pos);

  const [loading, setLoading] = useState(false);
  const [showReport, setShowReport] = useState(false);

  if (!UserReportCxt) {
    console.error(
      "UserReportProvider is missing. Wrap the parent component with <UserReportProvider>."
    );

    return (
      <td className={`tableData Name ${className}`}>
        {toPascalCase(row?.Name)}
      </td>
    );
  }

  const fetchLearnerReport = async (learner) => {
    try {
      setLoading(true);

      const batchId =
        (Alert.isAdmin && !Alert.isFromProfile.current) ||
          (getDataFromStorage("role") === "hr" &&
            !Alert.isFromProfile.current)
          ? id
          : Alert.isFromProfile.current ||
            getDataFromStorage("role") === "customer"
            ? Alert.selectedBid.bid
            : localStorage.getItem("batchid");


      console.log("learner id :", learner);
      console.log("learner user id :", learner.learnerid);
      const response = await axios.get(
        `node/learner/${learner.learnerid}/batch/${batchId}/testpoints?istagged=false`,
        commonFunctions.getHeaderDetailsForAxios()
      );

      if (response.data.resultCode !== 1000) {
        Alert.setShowNotify({
          show: true,
          title: "Info",
          msg: response.data.msg,
        });
        return;
      }

      if (
        Object.keys(response.data).length === 0 ||
        response.data.resultCode ===
        constants.RESULT_STATUS.NO_DATA
      ) {
        UserReportCxt.setUserTestResultTableData([]);

        Alert.setShowNotify({
          show: true,
          title: "Info",
          msg: "No data to display",
        });

        return;
      }

      response.data.data.data.sort(
        (a, b) => a.orderno - b.orderno
      );

      reportTableHooks.generateDataForUserTestResultReportTable(
        response.data.data.data
      );
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false); 
    }
  };

  const handleUserLpData = async () => {
    console.log("Clicked NameCell", row);
    try {
      Alert.setShowBreadCrumbsData({
        from: "user",
        index: rowIndex,
        learnerId: row.learnerid,
        studentName: row.Name,
      });
      console.log("row.userId:", row);
      UserReportCxt.setCurrentLearnerDetails({
        value: row.learnerid,
        label: row.Name,
      });
      setShowReport(true);
      await fetchLearnerReport(row);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <td
        className={`tableData Name ${className}`}
        style={{ cursor: "pointer" }}
        onClick={handleUserLpData}
      >
        {toPascalCase(row?.Name) || "-"}
      </td>

      {loading ? createPortal(
        <Loading overlay />,
        target
      ) : showReport ? (
        <UserReport
          open={showReport}
          onClose={() => setShowReport(false)}
          learnerId={row.learnerid}
        />
      ) : null}
    </>
  );
};

export default NameCell;